import { Component, inject, OnInit, effect, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AppStateService } from '../../services/app-state.service';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { Web3Service } from '../../services/web3.service';

@Component({
  selector: 'app-tokens-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tokens-page.component.html'
})
export class TokensPageComponent implements OnInit {
  public state = inject(AppStateService);
  private http = inject(HttpClient);
  public authService = inject(AuthService);
  public web3Service = inject(Web3Service);
  private cdr = inject(ChangeDetectorRef);
  
  public circleWalletInfo: any = null;
  public isLoading = false;
  
  public supportedTokens: any[] = [];

  constructor() {
    effect(() => {
      if (this.authService.isAuthenticated()) {
        this.fetchFiatBalances();
      }
    });
  }

  ngOnInit() {
    this.fetchAllTokens();
  }

  fetchAllTokens() {
    this.http.get(`${environment.apiUrl}/user/token/list`).subscribe({
      next: (res: any) => {
        if (res.status && res.data) {
          this.supportedTokens = res.data;
          this.cdr.detectChanges();
        }
      },
      error: (err) => console.error('Error fetching tokens', err)
    });
  }

  fetchFiatBalances() {
    if (!this.authService.isAuthenticated()) return;
    this.isLoading = true;
    this.cdr.detectChanges();
    this.http.get(`${environment.apiUrl}/user/tokens/balance`).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.circleWalletInfo = res.data;
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  async buyToken(token: any) {
    if (!this.state.isWalletConnected()) {
      return alert('Please connect wallet first to identify you');
    }
    
    if (!this.authService.isAuthenticated()) {
      try {
        await this.authService.login(this.web3Service.address());
      } catch (err) {
        return; // Login failed or was cancelled
      }
    }

    this.http.post(`${environment.apiUrl}/user/tokens/buy`, { token: token.symbol }).subscribe({
      next: (res: any) => {
        if (res.success && res.data.redirectUrl) {
          window.location.href = res.data.redirectUrl;
        }
      },
      error: (err) => {
        console.error('Error initiating buy:', err);
      }
    });
  }

  async sellToken(token: any) {
    if (!this.state.isWalletConnected()) {
      return alert('Please connect wallet first to identify you');
    }

    if (!this.authService.isAuthenticated()) {
      try {
        await this.authService.login(this.web3Service.address());
      } catch (err) {
        return; // Login failed or was cancelled
      }
    }

    const amount = prompt(`How much ${token.symbol} would you like to sell?`);
    if (!amount) return;
    
    this.http.post(`${environment.apiUrl}/user/tokens/sell`, { token: token.symbol, amount }).subscribe({
      next: (res: any) => {
        if (res.success && res.data.redirectUrl) {
          window.location.href = res.data.redirectUrl;
        }
      },
      error: (err) => {
        console.error('Error initiating sell:', err);
      }
    });
  }

  getFiatBalanceFor(symbol: string): string {
    if (!this.circleWalletInfo || !this.circleWalletInfo.balances) return '0.00';
    const balanceObj = this.circleWalletInfo.balances.find((b: any) => b.token.symbol === symbol);
    return balanceObj ? balanceObj.amount : '0.00';
  }
}
